import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageMeta from '../components/PageMeta';
import '../styles/pages.css';

const QuemSomos: React.FC = () => {
  return (
    <div className="page-container">
      <PageMeta
        title="Quem Somos"
        description="Conheça a Agricampanha - Associação dos Agricultores da Região da Campanha. Fundada em 2018, em Bagé/RS, representamos e fortalecemos os produtores rurais da Campanha Gaúcha."
        url="/quem-somos"
      />
      <div className="page-header">
        <div
          className="page-header-bg"
          style={{ backgroundImage: "url('/img/hero-image.jpg')" }}
        />
        <div className="page-header-overlay" />
        <Container className="page-header-content">
          <span className="section-badge section-badge--solid">Sempre ao lado do produtor</span>
          <h1>Sobre a Agricampanha</h1>
        </Container>
        <div
          className="page-header-fita"
          style={{ backgroundImage: "url('/img/bg-fita.png')" }}
        />
      </div>

      <Container className="page-content">
        <Row>
          <Col lg={8} className="mx-auto">

            <section className="content-section">
              <h2>Nossa História</h2>
              <p>
                A <strong>Agricampanha - Associação dos Agricultores da Região
                da Campanha</strong> é uma entidade sediada em Bagé (RS) e fundada em 2018, com o objetivo de ampliar as oportunidades do setor agropecuário e fortalecer sua representatividade. A associação oferece aos seus associados:
              </p>
              <p>
                <ul>
                  <li>Cursos personalizados, de acordo com as necessidades de cada negócio e cultura produtiva</li>
                  <li>Palestras e eventos que apresentam as últimas tendências e inovações do setor</li>
                  <li>Mesa de negócios, para estabelecer parcerias e expandir mercados.</li>
                  <li>Pesquisas e estudos técnicos visando o auxilio nas tomadas de decisões estratégicas</li>
                  <li>Levantamentos entre produtores e representatividade classe nos cenários político e econômico</li>
                </ul>
              </p>
              <p>
                Além disso, a Agricampanha tem forte compromisso com a comunidade, promovendo ações sociais e projetos educativos voltados à comunicação sobre o agronegócio desde a base, incentivando o desenvolvimento sustentável da região e o bem-estar das comunidades locais.
              </p>
            </section>

            <section className="content-section">
              <h2>Missão</h2>
              <p>
                Representar, fortalecer e integrar os produtores rurais da
                Campanha, promovendo desenvolvimento sustentável, informação de
                qualidade e responsabilidade social na comunidade.
              </p>
            </section>

            <section className="content-section">
              <h2>Visão</h2>
              <p>
                Ser referência regional em representatividade e apoio ao
                produtor rural, contribuindo para o crescimento econômico e
                social da Campanha Gaúcha.
              </p>
            </section>

            <section className="content-section">
              <h2>Valores</h2>
              <ul className="values-list">
                <li><strong>Compromisso:</strong> Sempre ao lado do produtor</li>
                <li><strong>Integridade:</strong> Transparência em todas as ações</li>
                <li><strong>Colaboração:</strong> União entre produtores e empresas</li>
                <li><strong>Sustentabilidade:</strong> Produção responsável e consciente</li>
                <li><strong>Inovação:</strong> Busca constante por melhorias e tecnologia</li>
              </ul>
            </section>

            {/* Diretoria */}
            <section className="content-section">
              <h2>Diretoria Biênio 2024/2026</h2>

              <div className="qs-dir-unified">

                {/* Presidente */}
                <div className="qs-dir-row">
                  <span className="qs-dir-cargo">Presidente</span>
                  <span className="qs-dir-nome">André Marques Bordin</span>
                </div>

                {/* Pares Vice / Secretário / Tesoureiro */}
                <div className="qs-dir-pair-row">
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">1º Vice-Presidente</span>
                    <span className="qs-dir-nome">Thiago Andrade Aléssio</span>
                  </div>
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">2º Vice-Presidente</span>
                    <span className="qs-dir-nome">Raquel de Oliveira Taschetto Budó</span>
                  </div>
                </div>

                <div className="qs-dir-pair-row">
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">1º Secretário</span>
                    <span className="qs-dir-nome">Silvia Martins de Salles</span>
                  </div>
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">2º Secretário</span>
                    <span className="qs-dir-nome">Diego Andrade Aléssio</span>
                  </div>
                </div>

                <div className="qs-dir-pair-row">
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">1ª Tesoureira</span>
                    <span className="qs-dir-nome">Angelita Camponogara Aléssio</span>
                  </div>
                  <div className="qs-dir-cell">
                    <span className="qs-dir-cargo">2º Tesoureiro</span>
                    <span className="qs-dir-nome">Dari Raddatz Junior</span>
                  </div>
                </div>

                {/* Grupos */}
                <div className="qs-dir-group-header">Conselho Fiscal – Efetivo</div>
                <div className="qs-dir-group-names" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                  <span>Lafayette Moraes Ricardo Neto</span>
                  <span>João Honório Teixeira Dias</span>
                  <span>Gabriel Oliveira Zago</span>
                  <span>Cristiano Holz</span>
                </div>

                <div className="qs-dir-group-header">Conselho Fiscal – Suplente</div>
                <div className="qs-dir-group-names" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                  <span>Maicon Pazzinato</span>
                  <span>Philipe Paganella de Barros</span>
                  <span>Ronaldo Kasdorf</span>
                  <span>Maria de Lourdes Ceccon</span>
                </div>

                <div className="qs-dir-group-header">Assessoria Jurídica</div>
                <div className="qs-dir-group-names" style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}>
                  <span>Aline Chaves Dias Delabary</span>
                  <span>Everton Luis Dourado Trindade</span>
                </div>

                <div className="qs-dir-group-header">Assessoria Técnica</div>
                <div className="qs-dir-group-names" style={{ gridTemplateColumns: '1fr' }}>
                  <span>Antonielle Franchi Gallina</span>
                </div>

                <div className="qs-dir-group-header">Assessoria de Eventos</div>
                <div className="qs-dir-group-names" style={{ gridTemplateColumns: 'repeat(5, 1fr)' }}>
                  <span>Alex Renner</span>
                  <span>Felipe Langer Rockenbach</span>
                  <span>Dari Aliro Radattz</span>
                  <span>Fabiano Rita Vargas</span>
                  <span>Henrique de Bortoli Rossato</span>
                </div>

                <div className="qs-dir-group-header">Conselho de Administração</div>
                <div className="qs-dir-group-names qs-dir-group-names--last" style={{ gridTemplateColumns: 'repeat(4, 1fr)' }}>
                  <span>Gesiel Porciúncula dos Santos</span>
                  <span>João Augusto Librelotto Rubin</span>
                  <span>Valdir Donicht</span>
                  <span>Zélio Teixeira Dias</span>
                </div>

              </div>
            </section>

            {/* Foto da diretoria */}
            <div
              className="qs-photo-block"
              role="img"
              aria-label="Diretoria Agricampanha Biênio 2024/2026"
              style={{ backgroundImage: "url('/img/galeria-quem-somos-3.jpg')" }}
            />

          </Col>
        </Row>
      </Container>

      {/* CTA full-width — fora do container, cola no footer */}
      <section className="page-cta-full">
        <Container>
          <h2>Faça Parte</h2>
          <p>Junte-se a nós e fortaleça o agronegócio da Campanha Gaúcha.</p>
          <a href="/#contato" className="btn btn-primary btn-lg">
            Quero Ser Associado
            <i className="bi bi-arrow-right ms-2"></i>
          </a>
        </Container>
      </section>
    </div>
  );
};

export default QuemSomos;
